import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-office-committees',
  templateUrl: './admin-office-committees.component.html',
  styleUrls: ['./admin-office-committees.component.css']
})
export class AdminOfficeCommitteesComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  officecommittees: any[] = [];
  cols: any[];
  formdata;
  display = false;
  offices: SelectItem[] = [];
  roles: SelectItem[] = [];
  committees: SelectItem[] = [];
  result = '';
  subscriptions: Subscription[] = [];
  value: any;

  constructor(
    private adminService: AdminService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.cols = [
      { field: 'officeAbbreviation', header: 'Förkortning' },
      { field: 'officeName', header: 'Namn' },
      { field: 'committeeAbbreviation', header: 'Förkortning' },
      { field: 'committeeName', header: 'Namn' }
    ];
    this.getRoles();
  }

  getCommittees() {
    this.committees = [];
    this.adminService.GetCommittees().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.abbreviation + ' - ' + d.name, value: d.id
          };
          this.committees.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.committees.unshift(emptyrecord);
        this.getOffices();
      }
    });
  }

  getOffices() {
    this.offices = [];
    this.adminService.GetOffices().subscribe(data => {
      if (data) {

        data.forEach(d => {
          let record;
          if (d.roleDescription !== '') {
            record = {
              label: d.name + ' (' + d.roleDescription + ')', value: d.id
            };
          } else {
            record = {
              label: d.name, value: d.id
            }
          }
          this.offices.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.offices.unshift(emptyrecord);
        this.getOfficeCommittees();
      }
    });
  }

  getOfficeCommittees() {
    this.officecommittees = [];
    this.adminService.GetOfficeCommittees().subscribe(data => {
      if (data) {
        this.officecommittees = data;
      }
    });
  }

  addOfficeCommittee(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  cancelAdd() {
    this.display = false;
  }

  saveOfficeCommittees(evt) {
    this.adminService.AddOfficeCommittee(evt).subscribe(x => {
      this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Office Committee tillagt.' });
      this.getOfficeCommittees();
    });
  }

  getRoles() {
    this.roles = [];
    this.adminService.GetRoles().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.description, value: d.description
          };
          this.roles.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.roles.unshift(emptyrecord);
        this.getCommittees();
      }
    });
  }

  remove(rowData) {
    this.confirm(rowData);
  }

  confirm(rowdata) {
    this.confirmDialog(rowdata);
  }

  confirmDialog(rowdata): void {
     this.confirmationService.confirm({
      header: 'Information',
      message: 'Vill du radera vald office committee?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteOfficeCommittee(rowdata);
      },
      reject: () => {
      }
    });
  }

  deleteOfficeCommittee(rowdata) {
    this.adminService.RemoveOfficeCommittee(rowdata).subscribe(resp => {
      if (resp) {
        this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Office committee raderad.' });
        this.getOfficeCommittees();
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.value = null;
    this.globalfilter.nativeElement.value = null;
  }

  exportToCSV() {
    let firstrow = 'Ämbete Förkortning;Ämbete Namn;Utskott Förkortning;Utskott Namn;Behörighetsroll';
    const filnamn = 'OF_officecommittees';

    const excelrecords: any[] = [];
    this.officecommittees.forEach(r => {
      const row = {
        officeAbbreviation: r.officeAbbreviation,
        officeName: r.officeName,
        committeeAbbreviation: r.committeeAbbreviation,
        committeeName: r.committeeName
      }
      excelrecords.push(row);
    });
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }
}
